<template>
  <div
    class="px-2 rounded-t-lg w-full h-full overflow-y-auto relative"
    :style="backgroundStyle"
    :class="loggedIn ? 'pb-0' : 'pb-2'"
  >
    <GlobalDropdown v-if="isNotLoginPage" />
    <div class="h-full flex flex-col">
      <header
        class="flex-none py-2 relative max-h-[65vh] overflow-y-auto rounded-b-xl"
      >
        <slot name="header" :isViewScrolled="isMainViewScrolled"></slot>
      </header>
      <SearchWrapper
        v-if="loggedIn && displaySearch"
        class="max-h-5 mt-0 z-20 mx-4"
      />
      <main
        class="bg-white overflow-y-auto overflow-x-hidden rounded-lg flex-grow relative border-white border-2"
        ref="mainRef"
      >
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import GlobalDropdown from './GlobalDropdown.vue';
import SearchWrapper from '../Search/SearchWrapper.vue';
import { useAdminStore } from '@getmayday/vue-modules';

const adminStore = useAdminStore();
const { loggedIn } = storeToRefs(adminStore);

const configStore = useConfigStore();
const { integrationPrimaryColor } = storeToRefs(configStore);

const route = useRoute();
const mainRef = ref<HTMLElement | null>();
const isMainViewScrolled = ref(false);

const searchWhitelist = ['index', 'knowledge-viewer', 'collection-viewer'];

const props = defineProps({
  backgroundColor: {
    type: String,
    default: null,
  },
});

const displaySearch = computed(() => {
  if (!route.name || typeof route.name === 'symbol') return false;
  return searchWhitelist.includes(route.name);
});

const backgroundStyle = computed(() => {
  return `
  background: linear-gradient(to bottom, ${
    props.backgroundColor || integrationPrimaryColor.value
  } 0%, #ffffff calc(100% + 64px));
  `;
});

const isNotLoginPage = computed(() => route.name !== 'login');

onMounted(() => {
  if (!mainRef.value) return;
  mainRef?.value?.addEventListener('scroll', () => {
    const scrollPosition = mainRef.value?.scrollTop;
    if (!scrollPosition) return;
    isMainViewScrolled.value = scrollPosition > 20;
  });
});
</script>
